import tw from 'tailwind-styled-components'

export const TwStickerItemFilter = tw.div`
  min-w-16
  h-16
  text-11
  font-semibold
  flex
  items-center
  justify-center
  border-1
  border-transparent
  border-solid
  rounded-4
  bg-action-default
  text-icon-invert
`

export const TwFilterBlock = tw.div<{$filtersLength: number | undefined}>`
  rounded-4
  
  ${p => {
    return p.$filtersLength ? 'bg-action-default' : 'bg-icon-placeholder'
  }}
`
